export const Promise = window.Promise;


//////////////////
// WEBPACK FOOTER
// ./polyfill.js
// module id = null
// module chunks = 